/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Given an element and a sibling direction, returns that media element's next enabled sibling.
 * Media elements are nested 1 level deep.
 *
 * @param {Element} e The element.
 * @param {string} siblingDirection The sibling direction (previousSibling or nextSibling).
 * @return {Element} The sibling.
 */
export function getNextEnabledSibling(e, siblingDirection) {
  let sibling = e[siblingDirection];
  while (sibling && sibling.disabled) {
    sibling = sibling[siblingDirection];
  }
  return sibling;
}
